<template>
    <div class="hotel-block-header">
        <a class="hotel-block-header__back" href="javascript:void(0)" @click="$emit('goback')" v-if="agency">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </a>
        <div class="hotel-block-header__info">
            <span class="hotel-block-header__info__booking-number" v-if="orderNumber"><span v-text="translations.booking_number"></span> {{ orderNumber }}</span>
            <transition name="title-transition">
                <h3 v-text="hotel.title" v-if="hotel.title" @click="$emit('titleclick')"></h3>
            </transition>
            <transition name="location-transition">
                <h4 v-text="hotel.location" v-if="hotel.location && !agency"></h4>
            </transition>
            <div class="hotel-stars" v-if="hasStars">
                <svg v-for="(star, starKey) in stars" :key="starKey" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.99 30.39" class="hotel-stars__icon" :class="{'hotel-stars__icon--filled': star}"><path d="M31.94,11.54a1,1,0,0,0-1-.7H20.26L16.94.69a1,1,0,0,0-1.9,0L11.73,10.84H1a1,1,0,0,0-.95.7,1,1,0,0,0,.36,1.11l8.68,6.28L5.78,29.08A1,1,0,0,0,7.31,30.2L16,23.92l8.68,6.28a1,1,0,0,0,.59.19,1,1,0,0,0,.95-1.31L22.9,18.93l8.67-6.28a1,1,0,0,0,.37-1.11Z"/></svg>
            </div>
        </div>
        <div class="hotel-block-header__actions">
            <div class="hotel-review-btn-wrapper" :class="{'ratings-shown': showRating}" @click="showHoverRating" @mouseover="showHoverRating" @mouseout="hideHoverRating"  v-if="hasRating">
                <button class="hotel-review-btn">
                    <!-- Overhappy -->
                    <svg v-if="rating.recommendation >= 85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.4 358.4" :class="{'icon-overhappy': rating.recommendation >= 85}"><path d="M179.2,0C80.39,0,0,80.39,0,179.2S80.39,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.6,153.6,0,0,1,179.2,25.6"/><circle cx="240.64" cy="148.47" r="25.6"/><circle cx="117.77" cy="148.47" r="25.6"/><path d="M179.2,291A132.66,132.66,0,0,1,64.74,224.88,12.8,12.8,0,1,1,86.9,212.06a106.57,106.57,0,0,0,184.61,0,12.8,12.8,0,0,1,22.16,12.82A132.69,132.69,0,0,1,179.2,291Z"/></svg>
                    <!-- Happy -->
                    <svg v-if="rating.recommendation >= 60 && rating.recommendation < 85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.4 358.4" :class="{'icon-happy': rating.recommendation >= 60 && rating.recommendation < 85}"><path d="M179.2,0C80.4,0,0,80.4,0,179.2S80.4,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.64,153.64,0,0,1,179.2,25.6"/><circle cx="240.6" cy="148.5" r="25.6"/><circle cx="117.8" cy="148.5" r="25.6"/><path d="M179.2,280.7a131.53,131.53,0,0,1-87.4-33.1,12.82,12.82,0,1,1,17-19.2,106.73,106.73,0,0,0,141,0,12.82,12.82,0,0,1,17,19.2A132.42,132.42,0,0,1,179.2,280.7Z"/></svg>
                    <!-- Neutral -->
                    <svg v-if="rating.recommendation >= 35 && rating.recommendation < 60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.4 358.4" :class="{'icon-neutral': rating.recommendation >= 35 && rating.recommendation < 60}"><path d="M179.2,0C80.39,0,0,80.39,0,179.2S80.39,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.6,153.6,0,0,1,179.2,25.6"/><circle cx="240.64" cy="148.47" r="25.6"/><circle cx="117.77" cy="148.47" r="25.6"/><path d="M258.12,250.87H100.28a12.8,12.8,0,0,1,0-25.6H258.12a12.8,12.8,0,1,1,0,25.6Z"/></svg>
                    <!-- Sad -->
                    <svg v-if="rating.recommendation >= 0 && rating.recommendation < 35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.4 358.4" :class="{'icon-sad': rating.recommendation >= 0 && rating.recommendation < 35}"><path d="M179.2,0C80.4,0,0,80.4,0,179.2S80.4,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.64,153.64,0,0,1,179.2,25.6"/><circle cx="240.6" cy="148.5" r="25.6"/><circle cx="117.8" cy="148.5" r="25.6"/><path d="M258.1,265.4a13.24,13.24,0,0,1-8.5-3.2,106.73,106.73,0,0,0-141,0,12.82,12.82,0,1,1-17-19.2,131.94,131.94,0,0,1,174.8,0,12.82,12.82,0,0,1,1.1,18.1A12.12,12.12,0,0,1,258.1,265.4Z"/></svg>
                </button>
                <transition name="show-transition">
                    <div class="user-ratings user-ratings--help" v-if="showRatingHelp">
                        <span v-text="translations.rating_help"></span>
                    </div>
                </transition>
                <user-ratings :rating="hotel.rating" :open="showRating && hasRating" @close="showRating = false"></user-ratings>
            </div>
            <button v-if="showFavorite" @click="toogleFavorite" class="hotel-like-btn" :class="{'hotel-like-btn--saved': favorite}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.01 28.01"><path d="M16,27c-.58,0-1.53-1-2.29-1.71l-10-10A8.2,8.2,0,1,1,15.26,3.69L16,4.5l.74-.81A8.19,8.19,0,1,1,28.32,15.26l-10,10C17.54,26.06,16.59,27,16,27Z" class="hotel-like-btn__fill"/><path d="M22.81,2a7.19,7.19,0,0,1,4.84,12.52l0,0,0,0-10,10A9.42,9.42,0,0,1,16,26a9.81,9.81,0,0,1-1.58-1.39l-10-10,0,0,0,0A7.19,7.19,0,1,1,14.52,4.36L16,6l1.48-1.63A7.23,7.23,0,0,1,22.81,2m0-2A9.16,9.16,0,0,0,16,3,9.19,9.19,0,1,0,3,16L13,26c1,1,2,2,3,2s2-1,3-2L29,16A9.19,9.19,0,0,0,22.81,0Z" class="hotel-like-btn__stroke"/></svg>
            </button>
        </div>
    </div>
</template>

<script type="text/javascript">
    import _, { times } from 'underscore';
    import UserRatings from './../user-ratings.vue';
    import Moment from 'moment';

    export default {
        props: {
            hotel: {type: Object, default() {return { }}},
            agency: {type: Boolean, default: false },
            orderNumber: {type: String, default: null },
            showFavorite: {type: Boolean, default: true},
            forceFavorite: {type: Boolean, default: false}
        },
        data() {
            return {
                favorite: false,
                favoriteId: false,
                showRating: false,
                showRatingHelp: false,
                translations: APP_CONFIG.TRANSLATION.HOTEL_BLOCK_HEADER
            }
        }, 
        mounted() {
            this.checkIsFavorite();
        },
        watch: {
            'hotel.id'() {
                this.checkIsFavorite();
            },
            hasFavorites() {
                this.checkIsFavorite();
            }, 
            favoriteId() {
                if(this.favoriteId) {
                    this.favorite = true;
                } else {
                    this.favorite = false;
                }
            },
            showRatingDefault() {
                if(this.showRatingDefault) {
                    this.showRatingHelp = true;
                    setTimeout(() => {
                        this.showRatingHelp = false;
                    }, 5000);
                }
            },
            showRating() {
                if(this.showRating) {
                    this.$emit('showrating');
                }
            }
        },
        methods: {
            showHoverRating() {
                    this.showRating = true;
                    this.showRatingHelp = false;
            },
            hideHoverRating() {
                    this.showRating = false;
            },
            checkIsFavorite() {
                if(!this.showFavorite)
                    return;

                this.favoriteLoading = true;
                this.$store.dispatch('isFavorite', this.hotel.id).then((res) => {
                    this.favoriteId = res.id;
                    this.favoriteLoading = false;
                }).catch(() => {
                    this.favoriteLoading = false;
                    this.favoriteId = null;
                });
            },
            toogleFavorite() {
                if(this.favoriteLoading || !this.showFavorite || !this.hotel)
                    return;
                
                this.favoriteLoading = true;

                if(!this.favoriteId) {
                    let favoriteData = {
                        hotel: {
                            hotelId: this.hotel.id
                        }
                    };

                    this.favorite = true;
                    document.getElementsByTagName('body')[0].classList.add('main-app--like');
                    setTimeout(() => {
                        document.getElementsByTagName('body')[0].classList.remove('main-app--like');
                    }, 650);
                    
                    this.$store.dispatch('addFavorite', favoriteData).then((res) => {
                        this.$emit('addFavorite');
                        this.favoriteLoading = false;
                        this.favoriteId = res.id;
                    }).catch(() => {
                        this.favorite = false;
                        this.favoriteLoading = false;
                    })
                } else {
                    this.favorite = false;
                    this.$store.dispatch('removeFavorite', this.favoriteId).then(() => {
                        this.$emit('removeFavorite');
                        this.favoriteId = null;
                        this.favoriteLoading = false;
                    }).catch(() => {
                        this.favorite = true;
                        this.favoriteLoading = false;
                    })
                }
            }
        },
        computed: {
            showRatingDefault() {
                return (this.hotel.showRating) ? true : false;
            }, 
            hasFavorites() {
               return !_.isEmpty(this.$store.state.favorites);
            },
            hasRating() {
                return !_.isEmpty(this.hotel.rating);
            },
            rating() {
                return this.hotel.rating;
            },
            hasStars() {
                return (this.category !== null && this.category !== 0) ? true : false;
            },
            category() {
                return this.hotel.stars;
            },
            stars() {
                let stars = [ ];
                const hotelStarts = (this.category && this.category.value) ? this.category.value : 0;

                for(let i = 1; i<=5; i++) {
                    if(hotelStarts >= i) {
                        stars.push(true);
                    } else {
                        stars.push(false);
                    }
                }

                return stars;
            }
        },
        components: {
            UserRatings
        }
    }
</script>